import { Button } from 'reactstrap'
import { useDispatch } from 'react-redux'
import MESSAGES from 'core/data-model/constants/messages'
import { setAcceptIlpSaleSheet } from 'quick-quote/ui/actions'

export const AcceptIlpSaleSheetButton = (props) => {
  const dispatch = useDispatch()

  const handleSetAcceptIlpSaleSheet = async () => {
    dispatch(setAcceptIlpSaleSheet())
  }

  return (
    <Button
      color="primary"
      onClick={() => {
        handleSetAcceptIlpSaleSheet()
      }}
      disabled={props.disabled}
    >
      {MESSAGES.SUBMIT}
    </Button>
  )
}

export default AcceptIlpSaleSheetButton
